import { render, staticRenderFns } from "./surface_post_attachment.vue?vue&type=template&id=7cbdc0e1&scoped=true&"
import script from "./surface_post_attachment.vue?vue&type=script&lang=js&"
export * from "./surface_post_attachment.vue?vue&type=script&lang=js&"
import style0 from "./surface_post_attachment.vue?vue&type=style&index=0&id=7cbdc0e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cbdc0e1",
  null
  
)

export default component.exports